import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 20000 });

// Admin client attaches the shared-passcode bearer token
export const ADMIN_TOKEN_KEY = "ntq-admin-token";
const adminClient = axios.create({ baseURL: API, timeout: 20000 });
adminClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(ADMIN_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Public
export const submitContact = (data) => client.post("/contact", data).then((r) => r.data);
export const subscribeNewsletter = (email) => client.post("/newsletter", { email }).then((r) => r.data);
export const applyCareer = (data) => client.post("/careers/apply", data).then((r) => r.data);
export const chatSend = (session_id, message) => client.post("/chat", { session_id, message }, { timeout: 90000 }).then((r) => r.data);
export const chatLead = (data) => client.post("/chat/lead", data).then((r) => r.data);

// Admin auth
export const adminLogin = (passcode) => client.post("/admin/login", { passcode }).then((r) => r.data);
export const adminVerify = () => adminClient.get("/admin/verify").then((r) => r.data);

// Admin data
export const getContacts = () => adminClient.get("/contact").then((r) => r.data);
export const getNewsletter = () => adminClient.get("/newsletter").then((r) => r.data);
export const getApplications = () => adminClient.get("/applications").then((r) => r.data);
export const getLeadsSummary = () => adminClient.get("/leads/summary").then((r) => r.data);
export const getNotifications = () => adminClient.get("/notifications").then((r) => r.data);
export const markAllNotificationsRead = () => adminClient.post("/notifications/read-all").then((r) => r.data);

export default client;
